/* Superważny komentarz */
class Test {
	constructor() {
		console.log( 'Constructed' );
	}
}
